var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "delete-saved-search-modal",
        "cancel-title": _vm.$t("Cancel"),
        "ok-title": _vm.$t("Delete"),
        centered: "",
        "hide-header": "",
        "ok-variant": "danger"
      },
      on: { cancel: _vm.hideModal, close: _vm.hideModal, ok: _vm.handleOk }
    },
    [
      _c("div", { staticClass: "delete-container" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-between align-items-center mb-4"
          },
          [
            _c("span", { staticClass: "page-title" }, [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$t("Delete") +
                      " " +
                      _vm.theArticle +
                      (_vm.beginsWithVoyel ? "" : " ") +
                      _vm.$t(_vm.itemToString)
                  ) +
                  " "
              )
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "ph-custom ph-x-bold cursor",
              on: { click: _vm.hideModal }
            })
          ]
        ),
        _vm._v(" "),
        _vm.selectedItem !== null
          ? _c("div", { staticClass: "mb-4" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("Do.you.want.to.delete")) +
                  " " +
                  _vm._s(_vm.theArticle) +
                  _vm._s(_vm.itemToString) +
                  _vm._s(
                    " " +
                      (_vm.selectedItemName
                        ? '"' + _vm.selectedItemName + '"'
                        : "") +
                      " ?"
                  ) +
                  "\n    "
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-365d0166", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-365d0166","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/DeleteSavedSearchModal.vue
// module id = 5ko0
// module chunks = 0